<template lang="pug">
footer.v-page-footer.page-footer(v-if="footer" )
	.container
		.page-footer__layout
			slot(name="contacts" )
			slot(name="items" )
			slot(name="info" )
	.page-subfooter(v-if="footer.subfooter")
		.container
			.page-subfooter__layout
				.page-subfooter__cell(v-if="footer.subfooter.link")
					a.page-subfooter__link(
						:href="footer.subfooter.link?.href"
						:target="footer.subfooter.link?.target") {{ footer.subfooter.link?.text || 'Newit'}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			footer: {}
		};
	},

	methods: {
		dataSet(data) {
			this.footer = data;
		}
	}
};
</script>
